/* ActionButtonsLayout.tsx generated by @compiled/babel-plugin v0.36.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./ActionButtonsLayout.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
/** @jsxFrag */

import { useIntl } from 'react-intl-next';
import { useIsFlexElementWrapped } from '../../../hooks/useIsFlexElementWrapped';
import messages from '../messages';
var container = null;
var secondLevelContainer = null;
var compactSecondaryButtonsContainer = null;
/**
 * Layout for action buttons.
 *
 * Do not put any additional logic besides layout logic here, because the layout logic is kind of complex,
 * and  it will be hard to maintain it in the future!
 */
export function ActionButtonsLayout(_ref) {
  var cancelButton = _ref.cancelButton,
    primaryButtons = _ref.primaryButtons,
    secondaryButtons = _ref.secondaryButtons;
  // The Discard button should be the last when there are two lines of buttons.
  //
  // We can't do it just by CSS (for example, by order prop), because CSS order doesn't
  // affect the tab order.
  // And we can't use tabindex, because tabindex is global and change order of all elements.
  // That's why we need to render the Discard button in different places in the DOM,
  // based on the number of lines. Stupid but works=(
  //
  // Also, we can't determinate the line count based on container width
  // because the amount buttons can be different.
  // That's why we use the useIsFlexElementWrapped hook to determine the line count.
  //
  // See more why CSS order and tabindex don't work: https://tink.uk/flexbox-the-keyboard-navigation-disconnect/

  var _useIsFlexElementWrap = useIsFlexElementWrapped(),
    _useIsFlexElementWrap2 = _slicedToArray(_useIsFlexElementWrap, 2),
    setRootContainerElement = _useIsFlexElementWrap2[0],
    isRootContainerWrapped = _useIsFlexElementWrap2[1];
  var _useIsFlexElementWrap3 = useIsFlexElementWrapped(),
    _useIsFlexElementWrap4 = _slicedToArray(_useIsFlexElementWrap3, 2),
    setSecondLevelContainerElement = _useIsFlexElementWrap4[0],
    isSecondLevelContainerWrapped = _useIsFlexElementWrap4[1];
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement("div", {
    ref: setRootContainerElement,
    role: "group",
    "aria-label": formatMessage(messages.actionButtonsAccessibleLabel),
    className: ax(["_zulpu2gc _1e0c1txw _1n261g80 _1bahesu3 _ca0qze3t"])
  }, !isRootContainerWrapped && /*#__PURE__*/React.createElement("div", {
    className: ax(["_zulpu2gc _1e0c1txw _4cvr1h6o"])
  }, secondaryButtons), /*#__PURE__*/React.createElement("div", {
    ref: setSecondLevelContainerElement,
    className: ax(["_zulpu2gc _1e0c1txw _1n261g80 _1bahesu3 _ca0qze3t", "_18u01wug"])
  }, !isSecondLevelContainerWrapped && cancelButton, primaryButtons && /*#__PURE__*/React.createElement("div", {
    className: ax(["_zulpu2gc _1e0c1txw _1n261g80 _1bahesu3 _ca0qze3t"])
  }, primaryButtons), isSecondLevelContainerWrapped && cancelButton), isRootContainerWrapped && /*#__PURE__*/React.createElement("div", {
    className: ax(["_zulpu2gc _1e0c1txw _4cvr1h6o"])
  }, secondaryButtons));
}